export default function getSelectedLanguage(language) {
  if (language === 'pt') return 'ptBR';
  if (language === 'en') return 'enUS';
  return language;
}
